import React, {useEffect, useState} from 'react';
import Nav from "../../components/ui/nav/nav";
import style from "./settingsPage.module.scss"
import {useSettings} from "./hook/settings.hook";
import Input from "../../components/ui/input/input";
import InputMask from "react-input-mask";
import {toast} from "sonner";
const SettingsPage = () => {

    const {settings, updateSettings} = useSettings();

    const [data, setData] = useState();

    useEffect(() => {
        setData(settings);
    }, [settings]);


    const handleTimeChange = (e, flag) =>   {
        const value = e.target.value;
        const [hours, minutes] = value.split(":");

        const isValidHours = !hours || (parseInt(hours, 10) >= 0 && parseInt(hours, 10) <= 23  && parseInt(hours[0]) <= 2);
        const isValidMinutes = !minutes || (parseInt(minutes, 10) >= 0 && parseInt(minutes, 10) <= 59 && parseInt(minutes[0]) <= 5);

        if (isValidHours && isValidMinutes) {
            flag ? setData({...data, started: value}): setData({...data, end: value});

        }
    };


    const handleUpdateSettings = () => {
        if (data?.address === ""){
            toast.error("Введите корректный адрес");
            return
        }
        if (data?.end?.length !== 5){
            toast.error("Введите корректное время окончаний работы");
            return
        }
        if (data?.started?.length !== 5){
            toast.error("Введите корректное время начало работы");
            return
        }
        if (data?.phone.replace(/[^\d+]/g, '').length !== 12){
            toast.error("Введите корректный номер телефона");
            return
        }

        updateSettings(data);

    }

    return (
        <div className="page">
            <div className="page_container">
                <div className={style.block}>
                    <Nav title="Настройки">
                        <div className={style.body}>
                            <div className={style.column}>
                                <Input label={"Адрес"} value={data?.address} setValue={(n)=> setData({...data, address: n})} placeholder={"Пролетарская 176"}/>
                                <Input type={"phone"} label={"Телефон"} value={data?.phone} setValue={(n)=> setData({...data, phone: n})} placeholder={"+7 (928) 464-02-22"}/>
                                <div className={style.pickTime}>
                                    <div className={style.pickTimeLabel}>Режим работы</div>
                                    <div>
                                        <div>
                                            <InputMask
                                                mask="99:99"
                                                maskChar={null}
                                                placeholder="ЧЧ:MM"
                                                value={data?.started}
                                                className={style.pickTimeInput}
                                                onChange={(e)=>handleTimeChange(e, 1)}
                                            />
                                        </div>
                                        <div className={style.separator}></div>
                                        <div>
                                            <InputMask
                                                mask="99:99"
                                                maskChar={null}
                                                placeholder="HH:MM"
                                                value={data?.end}
                                                className={style.pickTimeInput}
                                                onChange={(e)=>handleTimeChange(e, 0)}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <button className={style.btnSave} onClick={handleUpdateSettings}>Сохранить</button>
                            </div>
                            <div className={style.column}>

                                <Input label={"“VK”"} value={data?.vk} setValue={(n)=> setData({...data, vk: n})} placeholder={"Пролетарская 176"}/>
                                <Input label={"“Telegram”"} value={data?.tg} setValue={(n)=> setData({...data, tg: n})} placeholder={"Пролетарская 176"}/>
                                <Input label={"“Inastagram”"} value={data?.inst} setValue={(n)=> setData({...data, inst: n})} placeholder={"Пролетарская 176"}/>
                            </div>

                        </div>
                    </Nav>
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;